import { Type } from "class-transformer";
import {
    IsDateString,
    IsNotEmpty,
    IsNumber,
    IsOptional,
    IsString,
} from "class-validator";

export class ProjectExpensePaymentInstallmentDto {
    @IsNumber()
    @IsOptional()
    id!: number;

    @IsNumber()
    @IsOptional()
    position!: number;

    @IsDateString()
    @IsNotEmpty()
    payment_date!: string;

    @IsString()
    @IsNotEmpty()
    amount!: string;
}

export interface ProjectExpensePaymentInstallmentBody {
    payment_date: string;
    amount: string;
    position?: number;
}

export const projectExpensePaymentInstallmentsType = () =>
    Type(() => ProjectExpensePaymentInstallmentDto);
